/**
 * 区分 reportCategoryType（report_templates.report_category_type）
 * 出典：仕様書に値なし
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const REPORT_CATEGORY_TYPE_VALUES = ['sales', 'pipeline', 'activity', 'custom'] as const;

export type ReportCategoryType = (typeof REPORT_CATEGORY_TYPE_VALUES)[number];

export const REPORT_CATEGORY_TYPE_LABELS: Readonly<Record<ReportCategoryType, string>> = {
  sales: '売上',
  pipeline: 'パイプライン',
  activity: '活動',
  custom: 'カスタム',
};
